export default {
  roles: {},
  admins: {},
  entitlements: {}
}
